import * as types from './types'

// Mainmenu tabs
export const setActiveTab_action = (key) => ({
  type: types.SET_ACTIVE_TAB,
  key
})

export const toggleMainMenu_action = (status) => ({
  type: types.TOGGLE_MAINMENU,
  status
})

export const toggleInviteTeammates_action = (status) => ({
  type: types.TOGGLE_INVITE_TEAMMATES,
  status
})
export const getTotalItemsCount_action = () => ({
  type: types.GET_TOTALITEMS
})
export const setTotalItemsCount_action = (data) => ({
  type: types.SET_TOTALITEMS,
  data
})

export const doLogin_action = (data, resolve, reject) => ({
  type: types.LOGIN_USER,
  data,
  resolve,
  reject
})
export const doSocialLogin_action = (data, resolve, reject) => ({
  type: types.SOCIAL_LOGIN,
  data,
  resolve,
  reject
})
export const doRegister_action = (data, resolve, reject) => ({
  type: types.REGISTER_USER,
  data,
  resolve,
  reject
})

export const logout_action = () => ({
  type: types.LOGOUT_USER
})

export const getUserProfile_action = () => ({
  type: types.GET_USER_PROFILE
})

export const restoreSession = (keepModalsOpened) => ({
  type: types.RESTORE_SESSION,
  keepModalsOpened
})
export const setLoggedInUser = (data) => ({
  type: types.SET_LOGGED_IN_USER,
  data
})
export const updateUser_action = (data) => ({
  type: types.UPDATE_USER,
  data
})
export const setLoggedOutUser = (data) => ({
  type: types.SET_USER_LOGOUT,
  data
})

export const updateMembership_action = (data) => ({
  type: types.UPDATE_MEMBERSHIP,
  data
})

// Web Push Notification
export const getFCMToken = () => ({
  type: types.GET_FCM_TOKEN
})
export const setFCMToken = (token) => ({
  type: types.SET_FCM_TOKEN,
  token
})
export const setFCMloaded = (status) => ({
  type: types.SET_FCM_LOADED,
  status
})

export const updateNotificationSettings_action = (value) => ({
  type: types.UPDATE_NOTIFICATION_SETTINGS,
  value
})
export const updateExtensionSettings_action = (value) => ({
  type: types.UPDATE_EXTENSION_SETTINGS,
  value
})
export const setupFCM_action = () => ({
  type: types.SETUP_FCM
})

export const reseTeams_action = () => ({
  type: types.RESET_TEAMS
})
export const fetchTeams_action = () => ({
  type: types.GET_TEAMS
})
export const setTeams_action = (data) => ({
  type: types.SET_TEAMS,
  data
})

export const resetCompany_action = (value) => ({
  type: types.RESET_COMPANY,
  value
})
export const createCompany_action = (data, resolve, reject) => ({
  type: types.CREATE_COMPANY,
  data,
  resolve,
  reject
})
export const toggleCompanyLoading_action = (value) => ({
  type: types.TOGGLE_COMPANY_LOADING,
  value
})
export const getCompany_action = () => ({
  type: types.GET_COMPANY
})
export const setCompany_action = (data) => ({
  type: types.SET_COMPANY,
  data
})

// Notifications
export const getNotifications_action = (filters, resolve, reject) => ({
  type: types.GET_NOTIFICATIONS,
  filters,
  resolve,
  reject
})
export const addNotifications_action = (data) => ({
  type: types.ADD_NOTIFICATIONS,
  data
})

// Recent Activities
export const getRecentActivities_action = () => ({
  type: types.GET_RECENT_ACTIVITIES
})
export const setRecentActivities_action = (data) => ({
  type: types.SET_RECENT_ACTIVITIES,
  data
})
export const setMarkAsReadOnClick_action = (notiUser_id) => ({
  type: types.SET_MARK_AS_READ_ON_CLICK,
  notiUser_id
})
export const setMarkAllAsReadOnClick_action = () => ({
  type: types.SET_MARK_ALL_AS_READ_ON_CLICK
})

// Members
export const getMembers_action = () => ({
  type: types.GET_MEMBERS
})
export const setMembers_action = (data) => ({
  type: types.SET_MEMBERS,
  data
})

// Stripe Customer
export const setStripeCustomer_action = (data) => ({
  type: types.SET_STRIPE_CUSTOMER,
  data
})

// company storage utilization
export const setCompanyStorageUtilized_action = (bytes) => ({
  type: types.SET_COMPANY_STORAGE_UTILIZED,
  bytes
})

export const resetContent_action = () => ({
  type: types.RESET_CONTENT
})
export const getContents_action = (filters, resolve, reject) => ({
  type: types.GET_CONTENTS,
  filters,
  resolve,
  reject
})
export const setContents_action = (data, filters = {}) => ({
  type: types.SET_CONTENTS,
  data,
  filters
})
export const getDrafts_action = (resolve, reject) => ({
  type: types.GET_DRAFTS,
  resolve,
  reject
})
export const setDrafts_action = (data) => ({
  type: types.SET_DRAFTS,
  data
})
export const getPrivateAndFavoriteContents_action = (filters = {}, resolve, reject) => ({
  type: types.GET_PRIVATE_AND_FAVORITE_CONTENT,
  filters,
  resolve,
  reject
})
export const setPrivateAndFavoriteContents_action = (data, content_type) => ({
  type: types.SET_PRIVATE_AND_FAVORITE_CONTENT,
  data,
  content_type
})

// CATEGORIES
export const getCategories_action = (resolve, reject) => ({
  type: types.GET_CATEGORIES,
  resolve,
  reject
})
export const setCategories_action = (data) => ({
  type: types.SET_CATEGORIES,
  data
})
export const setLoadingCategoryId_action = (uuid) => ({
  type: types.SET_LOADING_CATEGORY_ID,
  uuid
})

export const createDraft_action = (data, resolve, reject, isEditing = false) => ({
  type: types.CREATE_DRAFT,
  data,
  resolve,
  reject,
  isEditing
})
export const saveContent_action = (data, resolve, reject) => ({
  type: types.SAVE_CONTENT,
  data,
  resolve,
  reject
})

// Page CATEGORIES
export const saveCategory_action = (data, resolve, reject) => ({
  type: types.SAVE_CATEGORY,
  data,
  resolve,
  reject
})

// MISC
export const toggleDeleteContentModal_action = (status, content, redirectToHome) => ({
  type: types.SHOW_DELETE_CONTENT_CONFIRM,
  status,
  content,
  redirectToHome
})

export const setIsEditingContentAction = (isEditingStatus) => ({
  type: types.SET_IS_EDITING_CONTENT,
  isEditingStatus
})

export const toggleContentPermissionModal_action = (status, content) => ({
  type: types.SHOW_CONTENT_PERMISSION_MODAL,
  status,
  content
})
export const toggleMoveToCategoryModal_action = (showMoveToCategoryModal, content) => ({
  type: types.SHOW_MOVE_TO_CATEGORY_MODAL,
  showMoveToCategoryModal,
  content
})
export const toggleDeleteCategoryModal_action = (status, category, redirectToHome) => ({
  type: types.SHOW_DELETE_CATEGORY_CONFIRM,
  status,
  category,
  redirectToHome
})
export const toggleCategoryModal_action = (status, category) => ({
  type: types.SHOW_CATEGORY_MODAL,
  status,
  category
})
export const importResponsesFromTray_action = (resolve, reject) => ({
  type: types.IMPORT_TRAY_CONTENT,
  resolve,
  reject
})

// Recent viewed content
export const getRecentlyVeiwedContent_action = () => ({
  type: types.GET_RECENT_VIEWED_CONTENT
})
export const setRecentlyViewedContent_action = (data) => ({
  type: types.SET_RECENT_VIEWED_CONTENT,
  data
})

export const toggleGlobalSearchModal_action = (status) => ({
  type: types.SHOW_GLOBAL_SEARCH_MODAL,
  status
})

export const toggleShareModal_action = (status, sharingPage = null) => ({
  type: types.TOGGLE_GUEST_SHARING_MODAL,
  status,
  sharingPage
})
export const refreshOnSharing_action = (status) => ({
  type: types.REFRESH_ON_SHARING,
  status
})
export const markAsFavorite_action = (content) => ({
  type: types.MARK_AS_FAVORITE,
  content
})
export const pinToCategory_action = (content, resolve, reject) => ({
  type: types.PIN_TO_CATEGORY,
  content,
  resolve,
  reject
})
export const setSortedCategories_action = (data, category_type) => ({
  type: types.SET_SORTED_CATEGORIES,
  data,
  category_type
})

export const toggleSettingsModal_action = (status) => ({
  type: types.TOGGLE_SETTINGS_MODAL,
  status
})

export const changeTab_action = (value) => ({
  type: types.CHANGE_TAB,
  value
})

export const resetTemplates_action = () => ({
  type: types.RESET_TEMPLATES
})
export const getAdminPageTemplates_action = () => ({
  type: types.GET_ADMIN_PAGE_TEMPLATES
})
export const setAdminPageTemplates_action = (data) => ({
  type: types.SET_ADMIN_PAGE_TEMPLATES,
  data
})

export const getTeamPageTemplates_action = () => ({
  type: types.GET_TEAM_PAGE_TEMPLATES
})
export const setTeamPageTemplates_action = (data) => ({
  type: types.SET_TEAM_PAGE_TEMPLATES,
  data
})

export const saveTemplate_action = (data, resolve, reject) => ({
  type: types.SAVE_TEMPLATE,
  data,
  resolve,
  reject
})

export const setNewTemplate_action = (data) => ({
  type: types.SET_NEW_TEMPLATE,
  data
})
export const setEditedTemplate_action = (data) => ({
  type: types.SET_EDITED_TEMPLATE,
  data
})

export const toggleTemplatesModal_action = (value) => ({
  type: types.TOGGLE_TEMPLATES_MODAL,
  value
})
export const toggleTemplatesSidebar_action = (value) => ({
  type: types.TOGGLE_TEMPLATES_SIDEBAR,
  value
})

export const toggleResponsePacksModal_action = (value, categoryId) => ({
  type: types.TOGGLE_RESPONSE_TEMPLATES_MODAL,
  value,
  categoryId
})

export const resetSubsription_action = () => ({
  type: types.RESET_SUBSCRIPTION
})
export const getActiveSubscription_action = () => ({
  type: types.GET_ACTIVE_SUBSCRIPTION
})
export const setActiveSubscription_action = (data) => ({
  type: types.SET_ACTIVE_SUBSCRIPTION,
  data
})
export const toggleCardModal_action = (value) => ({
  type: types.TOGGLE_CARD_MODAL,
  value
})
export const toggleCheckoutModal_action = (value, isUpgradeStep4 = false) => ({
  type: types.TOGGLE_CHECKOUT_MODAL,
  value,
  isUpgradeStep4
})
export const toggleSubscriptionSuccessModal_action = (value) => ({
  type: types.TOGGLE_SUBSCRIPTION_SUCCESS,
  value
})
export const toggleSubmittingCard_action = (value) => ({
  type: types.TOGGLE_SUBMITTING_CARD,
  value
})
export const toggleInvoicesModal_action = (value) => ({
  type: types.TOGGLE_INVOICES_MODAL,
  value
})
export const addCard_action = (data, resolve, reject) => ({
  type: types.ADD_CARD,
  data,
  resolve,
  reject
})
export const deleteCard_action = (data, resolve, reject) => ({
  type: types.DELETE_CARD,
  data,
  resolve,
  reject
})
export const toggleSubmittingSubscription_action = (value) => ({
  type: types.TOGGLE_SUBMITTING_SUBSCRIPTION,
  value
})
export const createSubscription_action = (data, resolve, reject) => ({
  type: types.CREATE_SUBSCRIPTION,
  data,
  resolve,
  reject
})
export const updateSubcriptionPlan_action = (data, resolve, reject) => ({
  type: types.UPDATE_SUBSCRIPTION,
  data,
  resolve,
  reject
})
export const cancelSubscription_action = (data, resolve, reject) => ({
  type: types.CANCEL_SUBSCRIPTION,
  data,
  resolve,
  reject
})

export const toggleResumePlanModal_action = (value) => ({
  type: types.TOGGLE_RESUMEPLAN_MODAL,
  value
})
export const toggleInvoiceFetching_action = (value) => ({
  type: types.TOGGLE_INVOICE_FETCHING,
  value
})
export const resumeSubscription_action = () => ({
  type: types.RESUME_SUBSCRIPTION
})
export const fetchInvoices_action = () => ({
  type: types.FETCH_INVOICES
})
export const setInvoices_action = (data) => ({
  type: types.SET_INVOICES,
  data
})

export const toggleOnboardingPlansPopup_action = (status) => ({
  type: types.SHOW_ONBOARDING_PLANS_POPUP,
  status
})

export const toggleCreateItemsPopup_action = (status) => ({
  type: types.SHOW_CREATE_ITEMS_POPUP,
  status
})
export const setChangeLogs_action = (data) => ({
  type: types.SET_CHANGELOGS,
  data
})

export const setResponseDropdoenStatus = payload => ({
  type: types.SET_IS_RESPONSE_DROPDOWN_VISIBLE,
  payload
})

export const setResponseDropdownPosition = payload => ({
  type: types.SET_RESPONSE_DROPDOWN_POSITION,
  payload
})

export const setCurrentResponseDropdown = payload => ({
  type: types.SET_CURRENT_RESPONSE_DROPDOWN,
  payload
})

export const setPageDropdownStatus = payload => ({
  type: types.SET_IS_PAGE_DROPDOWN_VISIBLE,
  payload
})

export const setPageDropdownPosition = payload => ({
  type: types.SET_PAGE_DROPDOWN_POSITION,
  payload
})

export const setCurrentPageDropdown = payload => ({
  type: types.SET_CURRENT_PAGE_DROPDOWN,
  payload
})

export const setIsCopyingLoading = payload => ({
  type: types.SET_IS_COPYING_LOADING,
  payload
})

export const setDropdownDirection = payload => ({
  type: types.SET_DROPDOWN_DIRECTION,
  payload
})

export const saveIconAndCoverImage =  (payload) => ({
  type: types.SAVE_ICON_COVER_IMAGE,
  payload
})

export const deleteIconAndCoverImage =  (payload) => ({
  type: types.DELETE_ICON_COVER_IMAGE,
  payload
})

export const repositionCoverImage =  (payload) => ({
  type: types.REPOSITION_COVER_IMAGE,
  payload
})

export const setIsRequestCallComplete =  (payload) => ({
  type: types.SET_IS_REQUEST_CALL_COMPLETE,
  payload
})

export const setErrorBag =  (payload) => ({
  type: types.SET_ERROR_BAG,
  payload
})

export const setFullScreenStatus_action =  (payload) => ({
  type: types.SET_FULLSCREEN_STATUS,
  payload
})

export const setSelectedPageOrDraft = payload => ({
  type: types.SET_SELECTED_PAGE_OR_DRAFT,
  payload
})